import axios from 'axios';

export const state = {
  payoutItems: [],
  payoutItemsPagination: {},
  loading: false,
};

export const mutations = {
  setPayoutItems(context, payoutItems) {
    context.payoutItems = payoutItems;
    context.loading = false;
  },

  setPayoutItemsPagination(context, pagination) {
    context.payoutItemsPagination = pagination;
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async getPayoutItems({ commit, rootState }, query) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      commit('setLoading', true);

      const payoutItems = await axios.get(`${window.BASE_API.BAADER}/payout-items?${query}`, options)
        .then(response => response.data);

      commit('setPayoutItems', payoutItems.data);
      commit('setPayoutItemsPagination', payoutItems.pagination);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },
  async createPayoutItem(context, data) {
    return axios
      .post(`${window.BASE_API.BAADER}/payout`, data)
      .catch(error => Promise.reject(error));
  },
  async deletePayoutItem(context, id) {
    return axios
      .delete(`${window.BASE_API.BAADER}/payout-items/${id}`)
      .catch(error => Promise.reject(error));
  },
};

const payoutItemsStore = {
  state,
  mutations,
  actions,
};

export default payoutItemsStore;



// WEBPACK FOOTER //
// ./src/store/baader/payoutItemsStore.js